import * as z from "zod";
import { requiredString } from "components/form/utils";

export const challengeSchema = z.object({
  challenge: requiredString(),
  solution: z.string().optional().nullable(),
});
